// Mock data for Arranque Express BCN - English version
export const mockDataEn = {
  // Contact info
  contacts: {
    whatsapp: "+34613076099",
    phone: "+34 XXX XXX XXX",
    email: "info@arranqueexpressbcn.com"
  },
  
  // Pricing
  pricing: {
    day: {
      price: 69,
      hours: "8:00 AM - 10:00 PM",
      days: "Monday to Friday"
    },
    night: {
      price: 89,
      hours: "10:00 PM - 8:00 AM",
      days: "Nights"
    },
    weekend: {
      price: 99,
      hours: "All day",
      days: "Saturdays & Sundays"
    }
  },
  
  // Payment methods
  paymentMethods: [
    { name: "Bizum", icon: "smartphone" },
    { name: "Card", icon: "credit-card" },
    { name: "Cash", icon: "banknote" }
  ],
  
  // Service areas
  zones: [
    { name: "Barcelona City", supplement: 0, description: "All Barcelona neighborhoods" },
    { name: "Metropolitan Area", supplement: 0, description: "L'Hospitalet, Badalona, Santa Coloma..." },
    { name: "El Prat Airport", supplement: 25, description: "Terminals T1 & T2, parking lots" }
  ],
  
  // How it works steps
  howItWorks: [
    {
      step: 1,
      title: "Call or message us",
      description: "Contact us via WhatsApp or phone. We respond instantly."
    },
    {
      step: 2,
      title: "Quick arrival",
      description: "We arrive today with professional equipment."
    },
    {
      step: 3,
      title: "Successful jump-start",
      description: "We jump-start your car. You only pay if it works."
    }
  ],
  
  // Services list
  services: [
    {
      title: "12V Jump-start",
      description: "Professional jump-start with portable battery",
      icon: "zap"
    },
    {
      title: "24/7 Service",
      description: "Available every day of the year",
      icon: "clock"
    },
    {
      title: "On-site",
      description: "We come to you anywhere in Barcelona",
      icon: "map-pin"
    },
    {
      title: "Fixed price",
      description: "No surprises or hidden costs",
      icon: "euro"
    }
  ],
  
  // FAQ
  faq: [
    {
      question: "How long does it take to arrive?",
      answer: "We usually arrive in less than 1 hour. The exact time depends on traffic and location, but we'll always inform you of the estimated arrival time."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept Bizum, credit/debit cards, and cash. Payment is only made if we successfully jump-start your vehicle."
    },
    {
      question: "Do you work on weekends?",
      answer: "Yes, we offer service every day of the year, including weekends and holidays. Prices may vary depending on the schedule."
    },
    {
      question: "Does the price include travel?",
      answer: "Yes, the price includes travel within Barcelona's standard zone. For more distant areas, there may be a distance supplement."
    },
    {
      question: "What happens if you can't start the car?",
      answer: "If we can't start your vehicle after trying with our professional equipment, you won't pay anything. Our service is 100% free if unsuccessful."
    },
    {
      question: "Does it work with electric cars?",
      answer: "For electric or hybrid cars, we can only work on the 12V auxiliary battery, not on high-voltage systems for safety reasons."
    }
  ],
  
  // Company info
  company: {
    name: "ArrancaYa BCN",
    tagline: "We jump-start your car in Barcelona",
    slogan: "Faster than your insurance, cheaper than a tow truck",
    description: "Professional on-site vehicle jump-start service in Barcelona",
    logo: "/images/logo.png",
    heroImage: "/images/hero-arranque.jpg",
    keyPoints: [
      "We jump-start any type of car, we arrive with professional portable battery and you only pay if your car starts",
      "No need for a tow truck or waiting hours: we come by scooter with a professional portable battery and jump-start your car in minutes",
      "We don't replace the battery, we simply jump-start your vehicle",
      "100% refund if we can't start it",
      "Free travel within the coverage area"
    ],
    heroTitle: "Has your car run out of battery?",
    heroSlogan: "We jump-start it today",
    heroPoints: [
      "Express service in Barcelona",
      "Fixed price €69* VAT included",
      "You only pay if your car starts"
    ],
    whatsappCTA: "Request Jump-start",
    callCTA: "Call now"
  },
  
  // Car brands
  carBrands: [
    "Audi", "BMW", "Mercedes", "Volkswagen", "Ford", "Renault", "Peugeot", 
    "Citroën", "Opel", "Nissan", "Toyota", "Hyundai", "Kia", "Seat", 
    "Skoda", "Fiat", "Alfa Romeo", "Volvo", "Mazda", "Honda"
  ],

  // Barcelona images
  barcelonaImages: [
    "https://images.unsplash.com/photo-1583422409516-2895a77efded?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxCYXJjZWxvbmElMjBjaXR5fGVufDB8fHx8MTc1Nzg1MjI1Mnww&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/1388030/pexels-photo-1388030.jpeg",
    "https://images.unsplash.com/photo-1731266955612-67dab3692dfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxCYXJjZWxvbmElMjBzdHJlZXRzfGVufDB8fHx8MTc1Nzg1MjI2MHww&ixlib=rb-4.1.0&q=85"
  ]
};